module.exports = __webpack_public_path__ + "img/pay-zhifubao.e902e3c8.jpg";